import { render } from "./verify-account.vue?vue&type=template&id=11d30da9&scoped=true"
import script from "./verify-account.vue?vue&type=script&lang=js"
export * from "./verify-account.vue?vue&type=script&lang=js"

import "./verify-account.vue?vue&type=style&index=0&id=11d30da9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d30da9"]])

export default __exports__